import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const ModalContainer = styled(Box)(({
	theme,
}) => ({
	position: "relative",

	"& .MuiDialog-root": {
		position: "absolute !important",
	},
	"& .MuiBackdrop-root": {
		position: "absolute !important",
	},
}));

export default ModalContainer;